import React, { useCallback, useEffect, useState } from 'react';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { HashMatchHook } from 'utilities/hooks/hash-hook.js';

const getInitState = (isHashSelected: boolean, expandPayload: boolean = false) => {
  if (isHashSelected) {
    return true;
  }
  return expandPayload;
};

export const MobileSecondaryMajorModuleExpandedHook = ({
  title,
  name,
  urlSlug,
  expandMobile,
}: Pick<IModuleConfig, 'title' | 'name' | 'urlSlug'> & { expandMobile?: boolean }) => {
  const [isHashSelected] = HashMatchHook({ title, name, urlSlug });
  const [isExpanded, _setExpanded] = useState<boolean>(getInitState(isHashSelected, expandMobile));
  const setExpanded: React.MouseEventHandler<HTMLElement> = useCallback(() => _setExpanded((c) => !c), []);

  useEffect(() => {
    return () => {
      _setExpanded(getInitState(isHashSelected, expandMobile));
    };
  }, []);

  return [isExpanded, setExpanded] as const;
};
